import React from "react"
import {Head} from "./head"
import {MainBody} from "./mainbody"
import {FirebaseAuth} from "./firebase-auth"
import {useFirebaseUser} from "./firebase-auth"
import {ValidateWinner} from './validate-winner'

export default function App() {
  const firebaseUser = useFirebaseUser()

  return (
    <div>
      <Head />
      <FirebaseAuth />
      { firebaseUser.didAuth &&
        <div>
        <ValidateWinner accessToken={firebaseUser.accessToken} />
        </div>
      }
      <MainBody />
    </div>
  )
}
